import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, LoadingController, Loading, Content, Platform, PopoverController, Searchbar } from 'ionic-angular';
import { FormControl } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Page } from '../../enums/page.enum';
// import '../../../node_modules/rxjs/add/operator/debounceTime';
// import '../../../node_modules/rxjs/add/operator/distinctUntilChanged';
// import '../../../node_modules/rxjs/add/operator/switchMap';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

/* Models */
import { TransactionModel } from '../../models/order/transaction.model';
/* Pages & Popovers */
// import { TrackOrderDetail } from '../track-order-detail/track-order-detail';
// import { TrackOrderFilterPopover } from '../popover/track-order-filter-popover/track-order-filter-popover';
/* Filters & Services */
import { TxnDeliveryStatusFilter } from '../../filters/txndeliverystatus.pipe';
import { OrdStatusFilter } from '../../filters/ordStatusFilter.pipe';
import { NumFormatter } from '../../filters/num-formatter.pipe';
import { TransactionService } from '../../services/transaction.service';
import { UtilService } from '../../services/util.service';
import { OrderStatus } from '../../services/order-status';
import { StorageService } from '../../services/storage.service';

@IonicPage()
@Component({
    selector: 'track-order',
    templateUrl: 'track-order.html',
    providers: [TxnDeliveryStatusFilter, OrdStatusFilter, NumFormatter]
})
export class TrackOrder {
    @ViewChild(Content) content: Content;
    @ViewChild('searchbar') searchbar: Searchbar;

  term = new FormControl();
  txnList: TransactionModel[] = [];
  loading: Loading;
  loadingSO: Loading;
  showFilter: Boolean = false;
  showScrollToTop: Boolean = false;
  bottomPixel: string;
  direction: string;
  searchTerm: string = "";
  selectedOrdStatus: string;
  selectedCustCode: string = "";
  selectedOrdStartDate: string = "";
  selectedOrdEndDate: string = "";
  orderReceivedCode: string = "O";
  deliveryTransit: string = "S";
  custConfirmReceipt: string = "D";
  custCancelReceipt: string = "X";
  orderProcessCode: string = "K";
  orderHoldCode: string = "W";
  orderPartialCode: string = "B";
  orderSDBlock: string = "Q";
  //token: string = "";
  pageIndex: number = 0;
  // DMS STRY0015010 To allow DMS number to be searchable in order status
  selectedInvoiceNo: string = "";
  selectedDmsNo: string = "";
  // CCLIORDER-827 PO Enhancement
  poNo: string = "";

    isFirstLoad: Boolean = true;
    isVN: Boolean = false;
    constructor(
        private storage: Storage,
        public navCtrl: NavController,
        public navParams: NavParams,
        private txnService: TransactionService,
        public storageService: StorageService,
        private modalCtrl: ModalController,
        private alertCtrl: AlertController,
        private loadingCtrl: LoadingController,
        private platform: Platform,
        public popoverCtrl: PopoverController,
        private util: UtilService,
        private changeDetectorRef: ChangeDetectorRef) {
        this.isVN = this.util.isRemoveDKSHLogoForVN();
        this.selectedOrdStatus = "";
        this.selectedCustCode = "";
        this.poNo = "";

        // this.term.valueChanges 
        //          .debounceTime(1500)
        //          .distinctUntilChanged()
        //          .subscribe(data => {
        //              if (!this.isFirstLoad){
        //                  this.retrieveTransactionList(undefined, data);
        //              }
        //              else
        //                 this.isFirstLoad = false;
        //          })

        // this.term.valueChanges
        //     .pipe(debounceTime(1500), distinctUntilChanged())
        //     .subscribe(data => {
        //         if (!this.isFirstLoad) {
        //             this.retrieveTransactionList(undefined, data);
        //         }
        //         else
        //             this.isFirstLoad = false;
        //     })
    }

    searchOrder() {
        this.retrieveTransactionList();
    }

    ngOnInit() {
        this.storageService.setFromSession().then(() => {
            this.retrieveTransactionList();

            //KL - temp solution for mobile scrollToTop icon
            if (this.platform.is('mobile') == true) {
                this.bottomPixel = "80px";
            }
            this.selectedOrdStatus = '';
            this.selectedCustCode = '';
            this.selectedOrdStartDate = '';
            this.selectedOrdEndDate = '';

      this.content.ionScrollEnd.subscribe((data) => {
        if (data == null) {
          this.showScrollToTop = false;
        }
        else {
          let itemsInMobilePage = this.storageService.getItemsInMobilePage();
        if (data['scrollTop'] > 0) { this.showScrollToTop = true; }
        else { this.showScrollToTop = false; }
        if(this.txnList.length <= itemsInMobilePage) {this.util.checkHideFooter(this.txnList.length, '')}
        else if (data['directionY'] == "up") { this.util.checkHideFooter(10, data['directionY']) }
        this.direction = data['directionY'];
        }
      });
    });
  }

    refreshPage(refresher) {
        this.retrieveTransactionList();
        refresher.complete();
    }

  loadOrdOnScroll(infiniteScroll) {
    // if (this.searchTerm !== "") {
    //   infiniteScroll.complete();
    //   return;
    // }
    this.retrieveTransactionList(infiniteScroll);
  }

  retrieveTransactionList(infiniteScroll?: any, searchTerm?: string) {
    if (!navigator.onLine) {
      this.util.displayAlert(this.alertCtrl, "No internet", "There's no internet connection.");
      return;
    }
    if (infiniteScroll == undefined) {
      this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Preparing request data");
      this.pageIndex = 0; /* Reset back to 0 */
    }

        searchTerm = (this.searchTerm != "" ? this.searchTerm : "");
        this.txnService.retrieveTxnOrderStatusList(this.pageIndex, this.storageService.getSalesrepCode(),
            this.selectedOrdStatus, this.selectedCustCode, this.selectedOrdStartDate, this.selectedOrdEndDate, this.searchTerm.trim(),
            this.storageService.getSettingId(), this.selectedDmsNo, this.selectedInvoiceNo, this.poNo)
            .subscribe(
                (data) => {
                  let itemsInMobilePage = this.storageService.getItemsInMobilePage();
                  this.util.checkHideFooter(data.length, (this.searchTerm != "" && this.txnList.length <= itemsInMobilePage) ? 'down' : this.direction);                     
                  for (var i = 0; i < data.length; i++) {
                      data[i].u_created_date = this.util.convertUTCDateToLocalDate(data[i].u_created_date);
                      if(data[i].delivery_date != null && data[i].delivery_date != undefined && data[i].delivery_date !== "") {
                        data[i].delivery_date = this.util.convertUTCDateToLocalDateOnly(data[i].delivery_date);
                      }                       
                  }
                  this.pageIndex++;
                  if (infiniteScroll == undefined)
                      this.txnList = data;
                  else {
                      infiniteScroll.complete();
                      this.txnList = this.txnList.concat(data);
                  }
                },
                (err) => {
                    if (infiniteScroll !== undefined)
                        infiniteScroll.complete();
                    this.util.processError(this.loading, this.alertCtrl, err);
                },
                () => {
                    this.loading.dismiss();
                });
    }

    orderStatusDetails(txn: any) {
        this.navCtrl.push('TrackOrderDetail', txn);
    }
      
    viewPopover(myEvent) {
        let popover = this.popoverCtrl.create('TrackOrderFilterPopover', { status: this.selectedOrdStatus, cust: this.selectedCustCode });
        popover.present({
            ev: myEvent
        });

        popover.onDidDismiss((popoverData) => {
            if (popoverData != null && popoverData != undefined && popoverData != "") {
                this.selectedOrdStatus = popoverData.status;
                this.selectedCustCode = popoverData.custCode;
                // as common issue due to the timezone, startdate will be back date 1 day
                // convert to date and + 1 day
                if(popoverData.startDate != ""){
                    var date3 = new Date(popoverData.startDate);
                    date3.setDate(date3.getDate() + 1);
                    this.selectedOrdStartDate = date3.toISOString();
                }else{
                    this.selectedOrdStartDate = popoverData.startDate;
                }
                
                this.selectedOrdEndDate = popoverData.endDate;
                // DMS STRY0015010 To allow DMS number to be searchable in order status
                this.selectedDmsNo = popoverData.localRefNo;
                this.selectedInvoiceNo = popoverData.invoiceNo;
                this.poNo = popoverData.poNo;


                if (this.selectedCustCode == "" && this.selectedDmsNo == "") { this.retrieveTransactionList(); }
                else {
                    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Loading transaction order data");
                    // DMS STRY0015010 To allow DMS number to be searchable in order status (this.selectedInvoiceNo, this.selectedDmsNo);
                    // CCLIORDER-827 PO Enhancement - adding this.poNo
                    this.txnService.retrieveTxnOrderStatusList(this.pageIndex, this.storageService.getSalesrepCode(),
                        this.selectedOrdStatus, this.selectedCustCode, this.selectedOrdStartDate, this.selectedOrdEndDate, this.searchTerm.trim(),
                        this.storageService.getSettingId(), this.selectedDmsNo, this.selectedInvoiceNo, this.poNo)
                        .subscribe((msg) => {
                            if(msg.length > 0){
                                let SObyCustModal = this.modalCtrl.create('SObyCustomer', {data: msg}, {enableBackdropDismiss: false})
                                SObyCustModal.present();
                                SObyCustModal.onDidDismiss((p) => {
                                    switch(p.action){
                                        case "cancel" :
                                            this.selectedCustCode = "";
                                            return;
                                        case "proceed":
                                            this.loadingSO = this.util.displayLoading(this.loadingSO, this.loadingCtrl, "Almost there..");
                                            this.txnService.insertTxnOrderHistFromSAP(p.so.txn_no, this.storageService.getSettingId())
                                            .subscribe((a) => {
                                                if(a == true){
                                                    this.selectedCustCode = "";
                                                    this.selectedDmsNo = "";
                                                    this.searchTerm = p.so.txn_no;
                                                    this.retrieveTransactionList(undefined, this.searchTerm);
                                                }
                                            },
                                            (err)=>{this.util.processError(this.loadingSO, this.alertCtrl, err);},
                                            ()=>{this.loadingSO.dismiss();})
                                    }
                                });
                            }
                            else{
                                this.selectedCustCode = "";
                                this.util.displayAlert(this.alertCtrl, "No data", "No record(s) found");
                            }
                        },
                        (err) => {this.util.processError(this.loading, this.alertCtrl, err);},
                        () => {this.loading.dismiss();})
                }
            }
        })
    }

    getStatusDesc(txnStatus: string) {
        switch (txnStatus) {
            case OrderStatus.OrderReceived.Code: { return OrderStatus.OrderReceived.Header; }
            case OrderStatus.CustomerCancelOrder.Code: { return OrderStatus.CustomerCancelOrder.Header; }
            case OrderStatus.OrderInProcess.Code: { return OrderStatus.OrderInProcess.Header; }
            case OrderStatus.OrderOnHold.Code: { return OrderStatus.OrderOnHold.Header; }
            case OrderStatus.PartialOrderInProcess.Code: { return OrderStatus.PartialOrderInProcess.Header; }
            case OrderStatus.OrderSDBlock.Code: { return OrderStatus.OrderSDBlock.Header; }
            case OrderStatus.DeliveryInTransit.Code: { return OrderStatus.DeliveryInTransit.Header; }
            case OrderStatus.CustomerConfirmedOrder.Code: { return OrderStatus.CustomerConfirmedOrder.Header; }
            case OrderStatus.CustomerConfirmedRejection.Code: { return OrderStatus.CustomerConfirmedRejection.Header;}
            case OrderStatus.CustomerConfirmedReceiptOrRejection.Code: {return OrderStatus.CustomerConfirmedReceiptOrRejection.Header;}
            case OrderStatus.OrderPartialDeliver.Code: { return OrderStatus.OrderPartialDeliver.Header; }
            default: { return ""; }
        }
    }

    gotoPrevTab(e) {
        this.util.changeTab(this.loading, this.loadingCtrl, this.navCtrl, Page.TransactionHistList);
    }

    scrollToTop() {
        this.content.scrollToTop();
    }
}



// WEBPACK FOOTER //
// ./src/pages/track-order/track-order.ts